import dashboard from 'Modules/Dashboard/resources/lang/en-us.js'
import acl from 'Modules/ACL/resources/lang/en-us.js'
import currency from 'Modules/Currency/resources/lang/en-us.js'
import region from 'Modules/Region/resources/lang/en-us.js'
import user from 'Modules/User/resources/lang/en-us.js'
import affiliate from 'Modules/Affiliate/resources/lang/en-us.js'
import auth from 'Modules/Auth/resources/lang/en-us.js'
import alert from 'Modules/Alert/resources/lang/en-us.js'
import help from 'Modules/Help/resources/lang/en-us.js'
import pair from 'Modules/Pair/resources/lang/en-us.js'
import operator from 'Modules/Operator/resources/lang/en-us.js'
import recipient from 'Modules/Recipient/resources/lang/en-us.js'
import bank from 'Modules/Bank/resources/lang/en-us.js'
import transfer from 'Modules/Transfer/resources/lang/en-us.js'
import rebitAccount from 'Modules/RebitAccount/resources/lang/en-us.js'
import transaction from 'Modules/Transaction/resources/lang/en-us.js'
import exchange from 'Modules/Exchange/resources/lang/en-us.js'
import trade from 'Modules/Trade/resources/lang/en-us.js'
import ramp from 'Modules/Ramp/resources/lang/en-us.js'
import paymentMethod from 'Modules/PaymentMethod/resources/lang/en-us.js'
import notification from 'Modules/Notification/resources/lang/en-us.js'
import verificationType from 'Modules/VerificationType/resources/lang/en-us.js'
import testimonial from 'Modules/Testimonial/resources/lang/en-us.js'
import setting from 'Modules/Setting/resources/lang/en-us.js'

export default Object.assign({},
  dashboard,
  acl,
  currency,
  region,
  user,
  affiliate,
  auth,
  alert,
  help,
  pair,
  operator,
  recipient,
  bank,
  transfer,
  rebitAccount,
  transaction,
  exchange,
  trade,
  ramp,
  paymentMethod,
  notification,
  verificationType,
  help,
  testimonial,
  setting
)
